/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */
import { Component } from '@appCanvasCommon/component-system/Component';
import { ComponentInterface } from '@appCanvasCommon/interfaces/component.interface';
import { CanvasAngularLand } from '../../../../app-data/interfaces/canvas-angular-land';
import { AbstractApplication } from '@appCanvasCommon/core/AbstractApplication';
import { FancySprite } from '@appCanvasCommon/graphics/FancySprite';
import { Texture } from 'pixi.js-legacy';
import { FancyContainer } from '@appCanvasCommon/graphics/FancyContainer';
import { LayerPaths } from '@appPlanApplication/LayerPaths';
/**
 * This export component draws a white background behind the canvas when print preview is in the Edit state
 * The purpose for this is to handle cases where the canvas is transparent, so this guarantees we have a solid
 * white background when performing the print
 */
export class DrawWhiteBackground extends Component implements ComponentInterface {
	/**
	 * A sprite containing a 1px white texture. We scale this across the screen when print preview is enabled.
	 * @private
	 */
	private _sprite: FancySprite = new FancySprite(Texture.WHITE);
	/**
	 * Invoked once the lightbox is first created
	 * @param canvasAngularLand
	 * @param application
	 */
	public onExportPreviewStarted(
		canvasAngularLand: CanvasAngularLand,
		application: AbstractApplication
	): void {
		const container: FancyContainer | null = application.layerManager.getLayer(LayerPaths.BACKGROUND_VISUALS);
		if (container) {
			container.addChild(this._sprite);
			this._sprite.visible = true;
			this._sprite.width = application.camera.view.width;
			this._sprite.height = application.camera.view.height;
			this._sprite.moveToBack();
		}
	}
	/**
	 * Invoked once the export is finished
	 * @param canvasAngularLand
	 * @param application
	 */
	public onExportPreviewClosed(canvasAngularLand: CanvasAngularLand, application: AbstractApplication): void {
		const container: FancyContainer | null = application.layerManager.getLayer(LayerPaths.BACKGROUND_VISUALS);
		if (container) {
			container.removeChild(this._sprite);
		}
	}
}
